import { useEffect } from 'react';
import { useAuthentication } from '../../Login/hooks/useAuthentication';

export const LogoLink = () => {
    const { authentication, isAuthenticated } = useAuthentication();

    useEffect(() => {
        if (!authentication) {
            return;
        }

        if (!isAuthenticated) {
            if (!window.location.pathname.startsWith('/login')) {
                window.location.href = '/login';
            }
        }
    }, [authentication, isAuthenticated]);

    const logoLink = () => {
        if (isAuthenticated) {
            return '/';
        } else {
            return 'https://www.builderfinance.com';
        }
    };

    return (
        <>
            <div className='logoWrapper'>
                <a
                    href={logoLink()}
                    className='logo no-print'
                >
                    <img
                        src='/assets/img/logo.webp.html'
                        alt='Builder Finance'
                    />
                </a>
            </div>
        </>
    );
};
